import React, { ReactNode } from 'react';

import { LinearProgress } from '@material-ui/core';

import TranslationHelper from '../../../../../../../helpers/TranslationHelper';

import { IContractItem } from '../../../../../../../models/customerService';
import PaneHeader from '../../../../../../../components/PaneHeader';
import { useTaskPaneLoading } from '../../../../../../../state/ui/customerService/bottomGrid/tasks/index.hooks';
import ContractItemForm from '../../ContractItems/ContractItemForm';
import { BLANK_FORM_CONTRACT_ITEM } from '../../ClientsAndLocations/blankForms';
interface IOwnProps {
    contracItem?: IContractItem;
    handleClose: () => void;
    titleComponent?: ReactNode;
}
const ContractItemPane = ({
    contracItem,
    handleClose,
    titleComponent,
}: IOwnProps) => {
    const paneLoading = useTaskPaneLoading();

    const intialValues = { ...BLANK_FORM_CONTRACT_ITEM, ...contracItem };

    return (
        <>
            <PaneHeader
                onCloseClick={handleClose}
                title={TranslationHelper.translate('Contract item')}
                titleComponent={titleComponent}
            />

            {paneLoading || !contracItem ? (
                <LinearProgress />
            ) : (
                <ContractItemForm initialValues={intialValues} />
            )}
        </>
    );
};
export default ContractItemPane;
